<template>
  <div>
    <PermitBoxObtained
      v-if="isObtained"
      :permit="permit"
      @open-detail="handleOpen"
    />
    <PermitBoxInProgress
      v-else
      :permit="permit"
      @open-detail="handleOpen"
    />
    <PermitsDetailDialog
      :is-open="isDetailOpen"
      :permit="permit"
      @close="handleClose"
    />
  </div>
</template>

<script>
import PermitsDetailDialog from '@/components/Dialogs/PermitsDetailDialog.vue';
import PermitBoxInProgress from '@/components/Permits/PermitBoxInProgress.vue';
import PermitBoxObtained from '@/components/Permits/PermitBoxObtained.vue';

export default {
  components: {
    PermitBoxObtained,
    PermitsDetailDialog,
    PermitBoxInProgress,
  },
  props: {
    permit: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isDetailOpen: false,
    };
  },

  computed: {
    isObtained() {
      return this.permit.permit_status === 30;
    },
  },
  created() {
    const pathname = window.location.pathname;

    // This regex captures a path starting with foreigners/, followed by one or more non-slash characters (foreignerId),
    // then 'permits', and then one or more non-slash characters (permitId)
    const match = pathname.match(/foreigners\/([^\/]+)\/permits\/([^\/]+)/i);

    if (match) {
      // If there is a permitId in the URL, it will be in the second capturing group
      const pathPermitId = match[2];

      // Compare the permitId from URL with prop
      if(this.permit.id.toString() === pathPermitId) {
        this.isDetailOpen = true;
      }
    }
  },
  methods: {
    handleOpen() {
      // Extract path up to /permits/
      const newPath = window.location.pathname + '/' + this.permit.id + '/status';

      // Change URL without reloading the page
      window.history.pushState({}, '', newPath);

      this.isDetailOpen = true;
    },
    handleClose() {
      const currentPath = window.location.pathname;

      // This finds the index of '/permits' in the current pathname
      const permitsIndex = currentPath.indexOf('/permits');

      // This is to handle the case where the pathname does not contain '/permits'
      // If '/permits' is found, remove everything after that, otherwise, keep the pathname as is
      const newPath = permitsIndex !== -1 ? currentPath.substring(0, permitsIndex + '/permits'.length) : currentPath;

      // Update the browser URL without creating a new history entry
      window.history.replaceState({}, '', newPath);

      // Set the 'isDetailOpen' to false to close the detail
      this.isDetailOpen = false;
    },
  },
};
</script>
